// Ideally this is kept somewhere in database so we can do CRUD operations and centralise it for reuse.
export const simproJobZones: Record<
	string,
	{
		numeric: number;
		alphabetical: string;
		text: string;
	}[]
> = {
	'New Zealand': [
		{ numeric: isUat() ? 1 : 7, alphabetical: 'Bay of Plenty', text: 'Bay of Plenty' },
		{ numeric: isUat() ? 2 : 5, alphabetical: 'Canterbury', text: 'Canterbury' },
		{ numeric: isUat() ? 3 : 4, alphabetical: 'Central Districts', text: 'Central Districts' },
		{ numeric: isUat() ? 5 : 2, alphabetical: 'Northland', text: 'Northland' },
		{ numeric: isUat() ? 6 : 3, alphabetical: 'Southland and Otago', text: 'Southland and Otago' },
		{ numeric: isUat() ? 7 : 6, alphabetical: 'Taranaki', text: 'Taranaki' },
		{ numeric: isUat() ? 8 : 1, alphabetical: 'Waikato', text: 'Waikato' },
	],
	Ireland: [
		{ numeric: isUat() ? 4 : 39, alphabetical: 'Ireland', text: 'Ireland' }, // One zone for Ireland at the moment.
	],
};

function isUat() {
	return window.location.host.indexOf('uat') > -1;
}
